import React from "react";
import DateRangePicker from "../Component/DateRangePicker";
import { Button, Stack, Typography } from "@mui/material";
import InputSelectionComponent from "../Component/inputSelection";
import Filter from "../Component/Filter/Filter";
import AddFilter from "../Component/Filter/AddFilter";
import FilterList from "../Component/Filter/FilterList";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
const DashboardNav = ({
  activeTab,
  handleTabClick,
  selectedOptionShow,
  brandItems,
  selectedBrandItems,
  handleBrandCheckChange,
  handleProductCheckChange,
  selectedProductItems,
  productItems,
  inputValidation,
  isFirstTime,
  selectedPersona,
  handlePersonaCheckChange,
  personas,
  selectedGeographyItems,
  handleGeographyCheckChange,
  geography,
  selectedMarketItems,
  handleMarketCheckChange,
  markets,
  selectedLlmItems,
  handleLlmCheckChange,
  dbLlms,
  selectedSubFrequencyItems,
  handlesubFrequencyCheckChange,
  showData,
  isDone,
  handleClickShow,
  showFilterModal,
  filterModalType,
  setShowFilterModal,
  handleFilterItemSelect,
  handleFilterMenuSelect,
  isFilterActive,
  showNav = true,
  brandCategories,
  handleCategoryCheckChange,
  selectedCategory,
  categories,
  endDate,
  setEndDate,
  startDate,
  setStartDate,
  availableDates,
  setCustomDatesToDisplay,
  isReporting
}) => {
  return (
    <>
      {showNav && (
        <nav className="customTabs">
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              className={`nav-link ${activeTab === "overview" ? "active" : ""}`}
              id="nav-overview-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-overview"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected={activeTab === "overview"}
              onClick={() => handleTabClick("overview")}
              disabled={!showData || !isDone}
            >
              {selectedOptionShow === "Product" ? "Product" : "Brand"}
              {/* Overview */}
            </button>
            <button
              className={`nav-link ${activeTab === "category" ? "active" : ""}`}
              id="nav-category-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-category"
              type="button"
              role="tab"
              aria-controls="nav-ategory"
              aria-selected={activeTab === "category"}
              onClick={() => handleTabClick("category")}
              disabled={!showData || !isDone}
            >
              Category
            </button>
            <button
              className={`nav-link ${activeTab === "competition" ? "active" : ""
                }`}
              id="nav-competition-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-competition"
              type="button"
              role="tab"
              aria-controls="nav-competition"
              aria-selected={activeTab === "competition"}
              onClick={() => handleTabClick("competition")}
              disabled={!showData || !isDone}
            >
              Competition
            </button>
            <button
              className={`nav-link ${activeTab === "llm" ? "active" : ""}`}
              id="nav-llm-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-llm"
              type="button"
              role="tab"
              aria-controls="nav-llm"
              aria-selected={activeTab === "llm"}
              onClick={() => handleTabClick("llm")}
              disabled={!showData || !isDone}
            >
              LLM
            </button>
            <button
              className={`nav-link ${activeTab === "market" ? "active" : ""}`}
              id="nav-market-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-market"
              type="button"
              role="tab"
              aria-controls="nav-market"
              aria-selected={activeTab === "market"}
              onClick={() => handleTabClick("market")}
              disabled={!showData || !isDone}
            >
              Market
            </button>
            <button
              className={`nav-link ${activeTab === "personas" ? "active" : ""}`}
              id="nav-personas-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-persons"
              type="button"
              role="tab"
              aria-controls="nav-personas"
              aria-selected={activeTab === "personas"}
              onClick={() => handleTabClick("personas")}
              disabled={!showData || !isDone}
            >
              Personas
            </button>
            <button
              className={`nav-link ${activeTab === "sources" ? "active" : ""}`}
              id="nav-sources-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-sources"
              type="button"
              role="tab"
              aria-controls="nav-sources"
              aria-selected={activeTab === "sources"}
              onClick={() => handleTabClick("sources")}
              disabled={!showData || !isDone}
            >
              Sources
            </button>
          </div>
        </nav>
      )}

      <div className="customTabContent tab-content" id="nav-tabContent">
        <div
          className="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="nav-competition-tab"
        >
          <div className="row">
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-briefcase"></i>
                </span>
                {selectedOptionShow === "Company/Brand" ? (
                  <InputSelectionComponent
                    options={brandItems}
                    selectedOptions={selectedBrandItems}
                    handleChange={handleBrandCheckChange}
                  // type="brand"
                  />
                ) : (
                  <InputSelectionComponent
                    options={productItems}
                    selectedOptions={selectedProductItems}
                    handleChange={handleProductCheckChange}
                  // type="product"
                  />
                )}
              </div>
              {(selectedOptionShow === "Product"
                ? !inputValidation.selectedProductItems
                : !inputValidation.selectedBrandItems) &&
                !isFirstTime && (
                  <div className="position-absolute bottom-0 start-1">
                    <Typography color="error" variant="caption">
                      Please select a {selectedOptionShow}.
                    </Typography>
                  </div>
                )}
            </div>

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedCategory}
                  handleChange={handleCategoryCheckChange}
                  options={categories}
                // type="category"
                />
              </div>
              {!inputValidation.selectedCategory && !isFirstTime && (
                <div className="position-absolute bottom-0 start-1">
                  <Typography color="error" variant="caption">
                    Please select a Category.
                  </Typography>
                </div>
              )}
            </div>

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedPersona}
                  handleChange={handlePersonaCheckChange}
                  options={personas}
                // type="persona"
                />
              </div>
              {!inputValidation.selectedPersona && !isFirstTime && (
                <div className="position-absolute bottom-0 start-1">
                  <Typography color="error" variant="caption">
                    Please select a persona.
                  </Typography>
                </div>
              )}
            </div>
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedGeographyItems}
                  handleChange={handleGeographyCheckChange}
                  options={geography}
                // type="geography"
                />
              </div>
              {!inputValidation.selectedGeographyItems && !isFirstTime && (
                <div className="position-absolute bottom-0 start-1">
                  <Typography color="error" variant="caption">
                    Please select a geography.
                  </Typography>
                </div>
              )}
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedMarketItems}
                  handleChange={handleMarketCheckChange}
                  options={markets}
                // type="market"
                />
              </div>
              {!inputValidation.selectedMarketItems && !isFirstTime && (
                <div className="position-absolute bottom-0 start-1">
                  <Typography color="error" variant="caption">
                    Please select a market.
                  </Typography>
                </div>
              )}
            </div>

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-target"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedLlmItems}
                  handleChange={handleLlmCheckChange}
                  options={dbLlms}
                // type="llm"
                />
              </div>
              {!inputValidation.selectedLlmItems && !isFirstTime && (
                <div className="position-absolute bottom-0 start-1">
                  <Typography color="error" variant="caption">
                    Please select a llm.
                  </Typography>
                </div>
              )}
            </div>

            {!isReporting && <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <DateRangePicker
                  setCustomDatesToDisplay={setCustomDatesToDisplay}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  activeTarget={selectedSubFrequencyItems}
                  handleChange={handlesubFrequencyCheckChange}
                  availableDates={availableDates?.map((obj) => obj?.date)}
                  handleClickShow={isReporting ? () => {} : handleClickShow}
                />
              </div> </div>}

            <div className="col-md-3 d-flex align-items-start">
              <Button
                disabled={isFirstTime || (!showData && !isDone)}
                style={{
                  backgroundColor: "gainsboro",
                  borderColor: "gainsboro",
                  color: "black",
                  // textTransform: "capitalize",
                }}
                variant="contained"
                color={"secondary"}
                onClick={() => { handleClickShow() }}
                startIcon={
                  filterModalType === "NA" ? <DownloadIcon /> : <RefreshIcon />
                }
              >
                {filterModalType === "NA" ? "Generate" : "Refresh"}
              </Button>

              <Filter
                onSelectMenu={handleFilterMenuSelect}
                isFilterSet={isFilterActive}
              />
              {showFilterModal && filterModalType === "filter-list" && (
                <FilterList
                  open={showFilterModal}
                  onClose={() => setShowFilterModal(false)}
                  onSelect={handleFilterItemSelect}
                  type={selectedOptionShow === "Product" ? "product" : "brand"}
                />
              )}
              {showFilterModal && filterModalType === "add-new" && (
                <AddFilter
                  config={{
                    selectedLlmItems,
                    selectedBrandItems:
                      selectedOptionShow === "Product"
                        ? selectedProductItems
                        : selectedBrandItems,
                    selectedPersona,
                    selectedGeographyItems,
                    selectedFrequencyItems: selectedSubFrequencyItems,
                    selectedMarketItems,
                  }}
                  type={selectedOptionShow === "Product" ? "product" : "brand"}
                  open={showFilterModal}
                  onClose={() => setShowFilterModal(false)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardNav;